import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import { PageTitle } from '../../../../_metronic/layout/core';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import "./crecimientoMensual.css";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import AgTable from '../../../Components/Table/AgTable';
import DatePickerYear from 'react-datepicker';

export default function ProvisionVentas({ title }) {

    const [date, setDate] = useState(new Date());
    let dateFormated = ("0" + date.getDate()).slice(-2) + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/" + date.getFullYear()
    registerLocale('es', es);

    const animatedComponents = makeAnimated();
    const [unidadEconomica, setUnidadEconomica] = useState(Utilities.getListUnidadesEconomicas().list[0]);
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();

    const getOptionValue = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }
    const onChangeGraphType = (inputValue) => {
        //setEnableQuery(true); //Everytime the select changes, it enables the useQuery condition for CharFromServer
        setUnidadEconomica(inputValue);
    }

    const [auxData, setAuxData] = useState({ porcentajeReal: null, porcentajeProvisionado: null, total: null });

    const [codigoContrato, setCodigoContrato] = useState(null);

    function handleChangeCodigoContrato(event) {
        if (event.key === 'Enter') {
            setCodigoContrato(event.target.value);
        }
    }

    let header = [
        {
            headerName: 'Soc',
            field: 'soc',
            type: 'rightAligned',
        },
        {
            headerName: 'Unid Eco',
            field: 'unidadEconomica',
        },
        {
            headerName: 'Contrato',
            field: 'contrato',
            type: 'rightAligned',
        },
        {
            headerName: 'Cont-Ant',
            field: 'contAnt',
            type: 'rightAligned',
        },
        {
            headerName: 'Den-Cont',
            field: 'denCont',
        },
        {
            headerName: 'Moneda',
            field: 'moneda',
        },
        {
            headerName: 'Cent-Ben',
            field: 'centBen',
        },
        {
            headerName: 'Den-CBen',
            field: 'denCBen',
        },
        {
            headerName: 'T-Venta',
            field: 'tVenta',
        },
        {
            headerName: 'Den-TVenta',
            field: 'denTVenta',
        },
        {
            headerName: 'Periodo',
            field: 'periodo',
            type: 'rightAligned',
        },
        {
            headerName: 'Fecha',
            field: 'fecha',
        },
        {
            headerName: 'SinIGV',
            field: 'sinIGV',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.sinIGV, true)}</>
            )
        },
        {
            headerName: 'Cant',
            field: 'cantidad',
            type: 'rightAligned',
        },
        {
            headerName: 'Fecha Reg',
            field: 'fechaRegistro',
        },
        {
            headerName: 'Tipo D',
            field: 'tipoData',
        }
    ];

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.REPORTE_PROVISION]} >
                <PageTitle>{title}</PageTitle>
                <div className="card-header border-0 pt-6 row g-3 flex-wrap d-flex flex-row">
                    <div className="col-12 col-sm-4">
                        <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                        <Select
                            classNamePrefix='filter'
                            components={animatedComponents}
                            defaultValue={getOptionValue(unidadesEconomicasList.defaultId)}
                            isMulti={false}
                            closeMenuOnSelect={true}
                            options={unidadesEconomicasList.list}
                            onChange={(onChangeGraphType)}
                        />
                    </div>
                    <div className='col-12 col-sm-4'>
                        <div className="fw-bold fs-7 text-gray-600 mb-1">Fecha:</div>
                        <DatePickerYear
                            className="form-control form-control-transparent pe-5"
                            locale="es"
                            selected={date}
                            onChange={(dateX) => dateX && setDate(dateX)}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                            maxDate={new Date()}
                        />
                    </div>
                    <div className="col-12 col-sm-4">
                        <div className="fw-bold fs-7 text-gray-600 mb-1">Código Contrato:</div>
                        <input type="text" name="name" className="form-control"
                            onKeyDown={handleChangeCodigoContrato} />
                    </div>
                </div>

                <div className="row gy-5 g-xl-8 pt-6">
                    <div className="col-sm-4">
                        <div className="card bg-danger-mall card-xl-stretch mb-xl-8">

                            <div className="card-body">
                                <div className="d-flex text-center flex-column text-dark  ">
                                    <span className="fw-bold fs-7 text-red-mall">Porcentaje Real</span>
                                    <span className="fw-bolder fs-2x pt-1 text-red-mall">{auxData.porcentajeReal}%</span>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="col-sm-4">
                        <div className="card bg-danger-mall card-xl-stretch mb-xl-8">

                            <div className="card-body">
                                <div className="d-flex text-center flex-column text-dark  ">
                                    <span className="fw-bold fs-7 text-red-mall">Porcentaje Provisionado</span>
                                    <span className="fw-bolder fs-2x pt-1 text-red-mall">{auxData.porcentajeProvisionado}%</span>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div className="col-sm-4">
                        <div className="card bg-danger-mall card-xl-stretch mb-xl-8">

                            <div className="card-body">
                                <div className="d-flex text-center flex-column text-dark ">
                                    <span className="fw-bold fs-7 text-red-mall">Total</span>
                                    <span className="fw-bolder fs-2x pt-1 text-red-mall">{auxData.total || 0}</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mt-3 ">
                    <div className="card-body tab-content pt-6">
                        <AgTable
                            idContent={"Provision Ventas" + unidadEconomica.value + codigoContrato + date}
                            apiService={Api.ProvisionVentas}
                            setAuxData={setAuxData}
                            header={header}
                            titleExcel={"Provision Ventas - " + unidadEconomica.label + " " + codigoContrato + " " + dateFormated}
                            conditions={true}
                            args={{ anio: dateFormated.split('/')[2], mes: dateFormated.split('/')[1], unidadEconomicaId: unidadEconomica.value, codigoContratoId: codigoContrato, token: useGetToken() }} // * para filters
                            hideFilter={false}
                            paginationPageSize={8}
                            rowHeight={40}
                            useFlex={false}
                        />
                    </div>
                </div>
            </PermissionsGate>
        </>
    )
}